import { render, staticRenderFns } from "./FullReductionCard.vue?vue&type=template&id=d77cbc24&scoped=true&"
import script from "./FullReductionCard.vue?vue&type=script&lang=js&"
export * from "./FullReductionCard.vue?vue&type=script&lang=js&"
import style0 from "./FullReductionCard.vue?vue&type=style&index=0&id=d77cbc24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d77cbc24",
  null
  
)

export default component.exports